export { default as TikTokLoginQuery } from './TikTokLoginQuery.query';